import { Filter } from "@material-ui/icons";
import { Reducer } from "react";


export enum FilterName {
  CaseReference = "casereference",
  ClAccountId = "claccountid",
  AiProbability = "aiprobability",
  Classification = "classification",
  Client = "client",
  Description = "description",
  Group = "group",
  InvestorEmail = "investoremail",
  Owner = "owner",
  SlaStatus = "slastatus",
  Status = "status",
  Subject = "subject",
  StudioSendFailed = "studiosendfailed",
  Team = "team",
}

export type FilterState = Record<FilterName,Filter>

export const FilterLabels: Record<FilterName, string> = {
  [FilterName.CaseReference]: "Case #",
  [FilterName.ClAccountId]: "Account #",
  [FilterName.Owner]: "Assigned To",
  [FilterName.Classification]: "Classification",
  [FilterName.Client]: "Client",
  [FilterName.AiProbability]: "Confidence",
  [FilterName.Description]: "Description, filter by Team or Group first",
  [FilterName.StudioSendFailed]: "Failed to Send to Studio",
  [FilterName.InvestorEmail]: "From",
  [FilterName.Group]: "Group",
  [FilterName.SlaStatus]: "SLA Status",
  [FilterName.Status]: "Status",
  [FilterName.Subject]: "Subject",
  [FilterName.Team]: "Team",
};

export type Filter = {
  value: string;
  show: boolean;
};

export enum FiltersAction {
  CLEAR_VALUES,
  HIDE,
  REPLACE,
  SHOW,
  SET_VALUE,
}

export type clearValuesAction = {
  type: FiltersAction.CLEAR_VALUES;
};

export type hideAction = {
  type: FiltersAction.HIDE;
  filterName: FilterName;
};

export type replaceFiltersAction = {
  type: FiltersAction.REPLACE;
  newFilters: FilterState;
};

export type showAction = {
  type: FiltersAction.SHOW;
  filterName: FilterName;
};

export type setValueAction = {
  type: FiltersAction.SET_VALUE;
  filterName: FilterName;
  value: string;
};

export const filtersInitialState: FilterState = {
  [FilterName.CaseReference]: { value: "", show: true },  
  [FilterName.ClAccountId]: { value: "", show: false },
  [FilterName.Owner]: { value: "", show: false },
  [FilterName.Classification]: { value: "", show: false },
  [FilterName.Client]: { value: "", show: false },
  [FilterName.AiProbability]: { value: "", show: false },
  [FilterName.Description]: { value: "", show: false },
  [FilterName.StudioSendFailed]: { value: "", show: false },
  [FilterName.InvestorEmail]: { value: "", show: false },
  [FilterName.Group]: { value: "", show: true },
  [FilterName.SlaStatus]: { value: "", show: false },
  [FilterName.Status]: { value: "", show: false },
  [FilterName.Subject]: { value: "", show: false },
  [FilterName.Team]: { value: "", show: false },
};

const filtersReducer: Reducer<FilterState, clearValuesAction | hideAction | replaceFiltersAction | setValueAction | showAction> = (
  state,
  action
) => {
  switch (action.type) {
    case FiltersAction.CLEAR_VALUES: {
      const mutableFilters = { ...state };
      for (const key in state) {
        mutableFilters[key as FilterName].value = "";
      }
      return mutableFilters;
    }
    case FiltersAction.HIDE: {
      const mutableState = { ...state };
      mutableState[action.filterName as FilterName].value = "";
      mutableState[action.filterName as FilterName].show = false;
      return mutableState;
    }
    case FiltersAction.REPLACE: {
      return {...filtersInitialState, ...action.newFilters};
    }
    case FiltersAction.SHOW: {
      const mutableState = { ...state };
      mutableState[action.filterName as FilterName].show = true;
      return mutableState;
    }
    case FiltersAction.SET_VALUE: {
      const mutableState = { ...state };
      mutableState[action.filterName as FilterName].value = action.value;
      mutableState[action.filterName as FilterName].show = true;
      return mutableState;
    }
  }
};

export default filtersReducer;
